/*
When patching entities, the API expects media fields to be an array of IDs, not an array of media objects.
These functions replaces the media fields in a patch with the ID.
 */

export const siteMediaFields = [
  "primaryLogo",
  "backgroundImage",
  "genericImage",
  "sponsorImages",
  "presentingSponsorImages",
  "customFonts",
  "media",
  "announcements",
];

const categoryMediaFields = [
  "background",
  "cardBackground",
  "defaultPersonCardBackground",
];

const entryMediaFields = [
  "background",
  "cardBackground",
  "headshot",
  "media",
  "recordInfo.recordImage",
];

const imageHomeButtonMediaFields = ["data"];

/*
This function checks every field on the patch to see if it's media. If so, it maps to just the ID.
Note: it works on nested fields e.g. recordInfo.recordImage
 */
function updateMediaFields(patch, mediaFields) {
  // Helper function to get the value from a nested path
  function getMediaArrayFromPath(object, path) {
    return path
      .split(".")
      .reduce(
        (acc, key) =>
          acc && Object.prototype.hasOwnProperty.call(acc, key)
            ? acc[key]
            : undefined,
        object
      );
  }

  // Helper function to set the value at a nested path
  function setMediaArray(object, path, newValue) {
    const keys = path.split(".");
    let current = object;
    for (let i = 0; i < keys.length - 1; i += 1) {
      const key = keys[i];
      if (!current[key]) {
        current[key] = {};
      }
      current = current[key];
    }
    current[keys[keys.length - 1]] = newValue;
  }

  const updated = { ...patch };

  mediaFields.forEach((mediaField) => {
    const mediaArray = getMediaArrayFromPath(updated, mediaField);
    if (mediaArray !== undefined) {
      const newValue = mediaArray.map((mediaObject) => mediaObject._id);
      setMediaArray(updated, mediaField, newValue);
    }
  });

  return updated;
}

const updateSiteMedia = (patch) => updateMediaFields(patch, siteMediaFields);

const updateCategoryMedia = (patch) =>
  updateMediaFields(patch, categoryMediaFields);

const updateEntryMedia = (patch) => updateMediaFields(patch, entryMediaFields);

/*
Updates is an array of objects in this form:
[
  {
    path: "/entry/xyz", // path of doc
    entryID: "", // optional
    categoryID: "",
    updates: {
      field: "value"
    }
  }
]
 */
const updateEntryMediaBulk = (updates) =>
  updates.map((update) => ({
    ...update,
    updates: updateMediaFields(updates.updates, entryMediaFields),
  }));

const updateHomeButtonMedia = (homeButtons) =>
  homeButtons.map((item) => {
    if (item.type === "Image") {
      return updateMediaFields(item, imageHomeButtonMediaFields);
    }
    return item;
  });

export {
  updateSiteMedia,
  updateCategoryMedia,
  updateEntryMedia,
  updateEntryMediaBulk,
  updateHomeButtonMedia,
};
